import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { CheckmarkIcon, mq } from '@kvdbil/components';

const List = styled.ul`
  &:after,
  &:before {
    content: '';
    display: table;
  }

  &:after {
    clear: both;
  }
  display: block;

  &.twoCol {
    column-count: 1;
    column-gap: 1em;

    ${mq('mobileL')} {
      column-count: 2;
    }
  }

  &.threeCol {
    column-count: 3;
    column-gap: 1em;
  }

  &.threeColResponsive {
    column-count: 2;
    column-gap: 1em;

    ${mq('mobileM')} {
      column-count: 3;
    }
  }

  &.spacingWide {
    margin-top: -0.75rem;
  }

  &.in-line {
    display: inline;
  }
`;

const Icon = styled.span`
  position: relative;
  top: 0.375em;
  fill: inherit;
  width: auto;
  height: 0.625em;
  padding-right: 0.5rem;
  display: inline-block;
  vertical-align: top;

  &.colorOrange {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  &.colorBlue {
    color: ${({ theme }) => theme.colors.info.main};
  }

  &.colorRed {
    color: ${({ theme }) => theme.colors.error.main};
  }

  &.colorGreen {
    color: ${({ theme }) => theme.colors.secondary.main};
  }

  &.colorBlack {
    color: ${({ theme }) => theme.colors.text.dark};
  }

  &.colorYellow {
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;

const Item = styled.li`
  text-align: left;
  position: relative;
  white-space: nowrap;

  .bulletList--spacingWide & {
    padding-top: 0.75rem;
  }
`;

const Text = styled.span`
  display: inline-block;
  vertical-align: top;
  white-space: normal;
  padding-right: 1.5em;
`;

interface Props {
  bullets: string[];
  icon?: ReactElement;
}

const BulletList = ({
  bullets = [],
  icon = <CheckmarkIcon />,
  ...props
}: Props) => {
  return (
    <List className={'bulletList spacingWide twoCol'} {...props}>
      {bullets.map((bullet, key) => (
        <Item key={key}>
          <Icon className={'bulletList__icon colorOrange'}>{icon}</Icon>
          <Text>{bullet}</Text>
        </Item>
      ))}
    </List>
  );
};

export default BulletList;
